<template>
    <div class="loader-height">
        <b-loading :is-full-page="false" :active="true" :can-cancel="false"></b-loading>
    </div>
</template>

<script>
export default {
  name: "loading"
};
</script>

<style scoped>
.loader-height {
  height: 500px;
}
</style>
